import { CopyrightYear, PageDefinition } from "../../../Infrastructure/PageDefinition";
import { SettingService, SettingFilter, PrepareTranslate, Component, UserService, BaseTLDetailComponent, VersionService, AxiosResponse, tlLogDebug, tlLogError, GeneralTermService } from "../../../Infrastructure/CorBase/CoreBase";
	@Component
	export default class LoginBase extends BaseTLDetailComponent {
		protected versionNumberInLoginPage: string = "";

		CopyrightYear = CopyrightYear;
		versionService: VersionService = new VersionService();
		formData = {
			tenantIdentifier: '',
			userLogin: '',
			userPassword: '',
			authGoogle: false,
			authFacebook: false,

			code: ''
		};

		formDataSend = {
			tenantIdentifier: '',
			userLogin: '',
			userPassword: '',
			authGoogle: false,
			authFacebook: false
		};

		labelWidth = "0";
		inputWidth = "13";
		showRegistration = false;

		userService: UserService = new UserService();
		settingService: SettingService = new SettingService();
		generalTermService: GeneralTermService = new GeneralTermService();
		versionNumber: string = '';
		isActualVersion = false;
		languageSet = '';
		
		showGoogleLogin = false;
		isTestEnvironment = false;
		showTestPage = false;

		prepareTranslate = new PrepareTranslate();

		formDataGeneralTerm = {
			id: 0,
			idUser: 0,
			name: '',
			description: '',
			consentDate: '',
			consentUser: ''
		};

		allowGeneralTermBase(data:any) {
			this.formDataGeneralTerm.idUser = data.idUser;
			this.saveUserCredentials(data);
				this.generalTermService.consentGeneralTerm(data.idGeneralTerm, this.formDataGeneralTerm).then(res => {
				});
		}

		prepareDataSend() {
			this.formDataSend.tenantIdentifier = this.formData.tenantIdentifier;
			this.formDataSend.userLogin = this.formData.userLogin;
			this.formDataSend.userPassword = this.formData.userPassword;
			this.formDataSend.authGoogle = this.formData.authGoogle;
			this.formDataSend.authFacebook = this.formData.authFacebook;
		}

		forgetPasswordBase(){
			this.$router.push({ name: "PasswordChange", params: { id: this.$router.currentRoute.params.id, type: "newPassword" } });
		}

		registeredToSystemBase() {
			this.$router.push({ name: "RegistrationSelf", params: { id: this.$router.currentRoute.params.id } });
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		createdBase() {
			this.isLoginPage = true;
			this.initSelfRegistration();
		}

		continueLog = false;
		responsData: any;
		activeUserByUrl(code: string) {
			this.formData.code = code;

			this.userService.login(this.formData).then((response) => {
				this.continueLog = true;
				this.responsData = response.data;
				this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('login.registrationSuccess').toString());
				
			}).catch((error) => {
				this.showAlertModalWithTitleAndContent(this.$t('login.loginNotSuccess').toString(), this.$t('login.loginErrorNotCode').toString());
				this.formData.code = '';
				this.$router.replace({ name: "Login" });
			});

		}
		continueLogin() {
			if (this.continueLog) {
				this.saveUserCredentials(this.responsData);
			}
		}

		selfRegistrationBase(tenant: string) {
			this.$router.push({
				name: "UserRegistration", params: { tenant: tenant, goBack: "Login", type: "new" },
				query: { tenant: tenant, goBack: "Login", type: "new" }
			});
		}

		showRegistrationBase() {

			return this.showRegistration;
		}

		initSelfRegistration() {
			let settingFilter: SettingFilter = new SettingFilter(null, true, false, false, null, null, 'SET_SelfRegistration_Student_Enabled');
			this.settingService.getGlobalFilter(settingFilter).then((response) => {
				this.showRegistration = response.data as boolean;
				
				this.showRegistration = true;
				this.$store.commit("setSelfRegistrationstate", this.showRegistration);
			});
		}

		enterPress(): void {
			this.login();
		}

		login(login: string = '') {
			this.prepareDataSend();
			if (login != '') {
				this.formDataSend.userLogin = login;
			}

			this.userService.login(this.formDataSend).then((response) => {
				this.saveUserCredentials(response.data);
			}).catch((error) => {
				//this.formData.userLogin = this.formData.userLogin.substring(0, this.formData.userLogin.indexOf('@'));
				this.showAlertModalWithTitleAndContent(this.$t('login.loginNotSuccess').toString(), this.$t('login.loginError').toString());
			});
		}

		async googleLoginBase() {			
			try {
			
			//@ts-ignore
			//var signed = this.$gAuth.isAuthorized;
		
				//@ts-ignore
				//var load = await this.$gAuth.isLoaded();
			//@ts-ignore
				var googleUser = await this.$gAuth.signIn();			
				//@ts-ignore
				var profile = googleUser.getBasicProfile();
				//@ts-ignore
				this.formData.userLogin = profile.getEmail();
				this.formData.userPassword = '';
				this.formData.authGoogle = true;
				this.login();
			}
			catch (error) {
				tlLogError('GoogleLogin', error);
			}
		}

		getVersionNumberFromREST() {
			this.versionService.getAll().then((response) => {
				let versionNumber = response.data.version as string;
				this.isTestEnvironment = response.data.isTestingEnviroment;
				this.showTestPage = response.data.showTestPage;
				if (versionNumber && versionNumber.length > 0) {
					this.checkVersionNumber(response.data.version);
				}
			}).catch((error) => {
				this.checkVersionNumber('no version info');
			});
		}

		checkVersionNumber(versionNumberFromRest: string) {
			let versionNumberInStore = this.$store.state.versionNumber;
			let versionNumberInREST = versionNumberFromRest;
			if (versionNumberInStore != versionNumberInREST) {
				this.$store.commit('setVersionNumber', { versionNumber: versionNumberInREST });
				// VaP - dodelana kontrola, aby se obnoveni stranky nedelalo pri kazdem prvnim zobrazeni loginpage, ale jenom kdyz bude verze aplikace v prohlizeci jina nez je na serveru
				//     - puvodni logiku (versionNumberInStore != versionNumberInREST) ponecham, aby nedoslo k nekonecnemu refreshnuti stranky, p okud nekdo zapomene zmenit cislo verze v login.vue nebo ve VersionController.cs a cisla verzi byla jina
				if (this.versionNumberInLoginPage != versionNumberInREST) {
					window.location.reload();
				}
			} else {
				this.isActualVersion = true;
			}
			this.versionNumber = versionNumberInREST;
		}

		protected recongnizeLang(): void {
			var lang = navigator.language;
			lang = lang.substr(0, 2).toUpperCase();		
			if (this.$i18n.availableLocales.indexOf(lang) != -1) {
				this.$i18n.locale = lang;
			}
			else {
				this.$i18n.locale = 'EN';
			}
			this.$store.commit('setLanguage', lang);
		}

		showParamsErrorMessage() {
			let message: string = this.$router.currentRoute.params.errorMessage;
			let title: string = this.$t('login.loginError3').toString();
			if (message) {
				this.showAlertModalWithTitleAndContent(title, message);
			}
			
			this.formData.userLogin = this.formData.userLogin.substring(0,this.formData.userLogin.indexOf('@'));
		}


		protected setLanguage(lang: string): void {
			this.$i18n.locale = lang;
			this.$store.commit('setLanguage', lang);
			this.languageSet = lang;
		}

		saveUserCredentials(data: any) {
			if (data.isAuthenticated) {
				var lang = navigator.language.substr(0, 2).toUpperCase();
				if (this.$i18n.availableLocales.indexOf(lang) == -1) {
					lang = 'EN';
				}

		
				
				if (this.languageSet != '') {
					lang = this.languageSet;
				}
				this.$store.commit('login', {
					isLogged: true,
					perPage: data.rowsPerPage,
					rights: data.rightList,
					fullNameOrLogin: data.fullNameOrLogin,
					isSuperUser: data.isSuperUser,
					idUser: data.idUser,
					idPerson: data.idPerson,
					idTenant: data.idTenant,
					idStudent: data.idStudent,
					tenantModules: data.moduleList,
					jwtToken: data.tokenDTO.jwtToken,
					homePageIdentifier: data.homePageIdentifier,
					refreshToken: data.tokenDTO.refreshToken,
					tenantLanguages: data.languageCodeList,
					currentLanguage: data.preferredLanguageCode,
					askBeforeDelete: data.askBeforeDelete,
					askBeforeCancelEditing: data.askBeforeCancelEditing,
					showInfoMessagesOnDetail: data.showInfoMessagesOnDetail,
					allowOAuth: data.allowOAuth,
					showDetailParamFirstShow: data.showDetailParamFirstShow,
					pageTimer: data.pageTimer,
					ignoreDiacritics: data.ignoreDiacritics,
					isTestEnvironment: this.isTestEnvironment,
					showTestPage: this.showTestPage,
					globalSearchItemCount: data.globalSearchItemCount,
					notificationRefreshTimer: data.notificationRefreshTimer,
					isSelfRegistrationUser: data.isSelfRegistrationUser,
					isTeacher: data.isTeacher
				});

				var moduleList = this.setModules(data.moduleList);

				//zde dodani podle modulů
				this.prepareTranslate.addLangByModule(moduleList, data.languageCodeList, this.$i18n);
				//funguje
				//this.addLangByModule(data.moduleList, data.languageCodeList);

				this.goToFirstPage(data.homePageIdentifier, data.idStudent);

				//let returnRoute: string = this.getReturnRoute(data.homePageIdentifier);
				//this.$router.push(returnRoute);
			} else {
					this.showAlertModalWithTitleAndContent(this.$t('login.loginError2').toString(), JSON.stringify(data.errors));
			}
		};

		goToFirstPage(page: string, id: number) {
			var queryParam = Object.fromEntries(Object.entries(this.$store.state.lastRoutePageQuery).filter(([_, v]) => v != null));
			let returnRoute: string = this.getReturnRoute(page);




			returnRoute = returnRoute.replace('/', '');
			returnRoute = returnRoute.charAt(0).toUpperCase() + returnRoute.slice(1);
			//this.$router.push({ name: returnRoute, query: Object(queryParam) });
			this.$router.push({ name: returnRoute, query: Object(queryParam), params: Object(queryParam) });
		}

		//nastaveni minimalni modulů kvůli načteni lokalizace (u michaelu se uzivatel prihlasi ale nema zadne moduly)
		setModules(data: any) {
			var result = data as Array<string>;

			if (result.length == 0) {
				result.push('COR_User');
			}

			return result;
		}

		getAllowOauthBase() {
			let settingFilter: SettingFilter = new SettingFilter(null, false, false, false, null, null, 'SET_OAuth_Enabled');
			this.settingService.getGlobalFilter(settingFilter).then((response) => {			
				this.showGoogleLogin = response.data as boolean;
			});
		}

		getReturnRoute(homePageIdentifier: string): string {
			// vychozi url bude
			let returnRoute: string = 'GroupList';
			// a v pripade, ze cesta byla zadana pomoci url napr. http://127.0.0.1:6010/LoginHistoryList tak ji pouijeme primarne tu
			if (!(this.$store.state.lastRoutePage === 'Login' || !this.$store.state.lastRoutePage)) {
				returnRoute = this.$store.state.lastRoutePage;
			}


			
			// v pripade, ze ma nejakou cestu nastavenou v COR_Setting, tak pouzijeme tu
			if (this.$store.state.lastRoutePage != "/receiverAdd" && this.$store.state.lastRoutePage == '') {				
				returnRoute = PageDefinition.getMainPageByIdentifier(homePageIdentifier);
			}



			return returnRoute;
		}

		clearUserCredentials() {
			this.$store.commit('logout');
			// VaPTODO - az bude cas, tak spolu s logoutem udelat i revoke tokenu do REST API
		};

		onAlertModalOkClick() {

		}
	}

